/**
 * Drivers (owner, 5 Nov 2026: "drivers whatsapp number will be updated and they will get delivery challan on whats
 * app thats it rest remove everything driver related from app"). A list the office keeps — name and WhatsApp
 * number — that the dispatch bay picks from; each dispatch's challan goes to that number through the WhatsApp bot.
 * Drivers have no sign-in.
 */

/** The dispatch form's driver choices that are not a person on the list: nobody's WhatsApp gets the challan. */
export const DRIVER_OTHERS = ['DEALER DRIVER', 'customer', 'truck', 'Others'] as const;

export interface DriverRow {
  id: string;
  name: string;
  phone: string | null;
  isActive: boolean;
}

export const DRIVER_CHALLAN_STATUSES = ['WAITING', 'SENT', 'NO_NUMBER', 'CANCELLED'] as const;
export type DriverChallanStatus = (typeof DRIVER_CHALLAN_STATUSES)[number];

export const DRIVER_CHALLAN_LABELS: Record<DriverChallanStatus, string> = {
  WAITING: 'Challan waiting for WhatsApp',
  SENT: 'Challan sent on WhatsApp',
  NO_NUMBER: 'No WhatsApp number for the driver',
  CANCELLED: 'Challan not sent — dispatch removed',
};

/** A dispatch's challan to its driver, as the register shows it. */
export interface DriverChallanView {
  status: DriverChallanStatus;
  driverName: string;
  sentAt: string | null;
}

/** A WhatsApp number as typed: digits, an optional leading +, 10 to 15 digits. Null when there is none. */
export function driverPhoneProblem(phone: string | null | undefined): string | null {
  const typed = (phone ?? '').trim();
  if (!typed) return null;
  const digits = typed.replace(/[\s-]/g, '');
  return /^\+?\d{10,15}$/.test(digits) ? null : 'A WhatsApp number is 10 digits, or the full number with the country code.';
}
